import alt from "../alt";

class AnalyticsActions {
  constructor() {
    this.generateActions(
      "fetchEventTicketSales",
      "fetchEventBucketOverview",
      "fetchEventBucketSales",
      "fetchPassBucketSales",
      "fetchPassBucketsOverview",
      "fetchAttendeeAnalytics",
      "fetchGeoAnalytics",
      "fetchEventSalesAnalytics",
      "clearFetchEventSalesAnalyticsInterval",
      "fetchEventSalesDetailAnalytics",
      "fetchEventPassesAnalytics",
      "fetchPassSalesAnalytics",
      "fetchSalesAnalytics",
      "fetchEventTicketAnalytics",
      "fetchRecurringPassAnalytics",
      "fetchExpiredPassAnalytics",
      "fetchNewSubscriptionAnalytics",
      "fetchFailed"
    );
  }

  updateEventTicketSales(id, saleData) {
    return { id, saleData };
  }

  updateEventBucketSales(id, saleData) {
    return { id, saleData };
  }

  updateEventBucketOverview(id, overview) {
    return { id, overview };
  }

  updatePassBucketSales(id, saleData) {
    return { id, saleData };
  }

  updatePassBucketsOverview(id, overview) {
    return { id, overview };
  }

  updateAttendeeAnalytics(id, overview) {
    return { id, overview };
  }

  updateGeoAnalytics(id, overview) {
    return { id, overview };
  }

  updateEventSalesAnalytics(id, overview) {
    return { id, overview };
  }

  updateEventSalesDetailAnalytics(id, overview) {
    return { id, overview };
  }

  updateEventPassesAnalytics(id, overview) {
    return { id, overview };
  }

  updatePassSalesAnalytics(id, overview) {
    return { id, overview };
  }

  updateSalesAnalytics(id, overview) {
    return { id, overview };
  }

  updateEventTicketAnalytics(id, overview) {
    return { id, overview };
  }

  updateRecurringPassAnalytics(id, overview) {
    return { id, overview };
  }

  updateExpiredPassAnalytics(id, overview) {
    return { id, overview };
  }

  updateNewSubscriptionAnalytics(id, overview) {
    return { id, overview };
  }

  fetchAttendeeAnalyticsForVenue(eventBucketId, venueId) {
    return { eventBucketId, venueId };
  }

  fetchAttendeeAnalyticsForTag(eventBucketId, tagId) {
    return { eventBucketId, tagId };
  }
}

export default alt.createActions(AnalyticsActions);



// WEBPACK FOOTER //
// ./src/app/actions/AnalyticsActions.js